import { Activity, AlertCircle, BarChart3, CalendarRange, ShieldCheck } from 'lucide-react';

type PhoneMockupProps = {
  variant: 'planning' | 'monitoring' | 'injury';
  rotate?: string;
};

function PlanningUi() {
  return (
    <div className="space-y-2">
      <div className="rounded-lg bg-blue-50 p-2 text-xs font-medium text-brand-700">Microciclo semanal</div>
      <div className="space-y-2 rounded-lg border border-stroke bg-white p-2 text-[11px]">
        {['Fuerza Tren Inferior', 'Movilidad y Core', 'Velocidad + Técnica'].map((item) => (
          <div key={item} className="flex items-center justify-between">
            <span className="text-slate-700">{item}</span>
            <span className="rounded-full bg-brand-100 px-2 py-0.5 text-[10px] text-brand-700">45'</span>
          </div>
        ))}
      </div>
      <div className="flex gap-2 text-[10px]">
        <span className="rounded-full bg-emerald-100 px-2 py-1 text-emerald-700">Listo</span>
        <span className="rounded-full bg-amber-100 px-2 py-1 text-amber-700">Revisión</span>
      </div>
    </div>
  );
}

function MonitoringUi() {
  return (
    <div className="space-y-2">
      <div className="grid grid-cols-3 gap-2 text-[10px]">
        {[
          { label: 'RPE', value: 7.1 },
          { label: 'TQR', value: 5.8 },
          { label: 'UA', value: 412 }
        ].map(({ label, value }) => (
          <div key={label} className="rounded-lg bg-slate-50 p-2 text-center">
            <p className="font-semibold text-slate-700">{label}</p>
            <p className="mt-1 text-brand-600">{value}</p>
          </div>
        ))}
      </div>
      <div className="rounded-lg border border-stroke p-2">
        {[78, 52, 85, 61, 72].map((value, index) => (
          <div key={value} className="mb-1 last:mb-0">
            <div className="h-1.5 rounded-full bg-slate-100">
              <div className="h-1.5 rounded-full bg-brand-500" style={{ width: `${value}%` }} />
            </div>
            <p className="text-[9px] text-slate-500">Día {index + 1}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

function InjuryUi() {
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between rounded-lg bg-red-50 px-2 py-1.5 text-[10px] text-red-700">
        <span>Riesgo de lesión</span>
        <span className="font-semibold">Moderado</span>
      </div>
      {[
        { text: 'Asimetría de salto', icon: AlertCircle },
        { text: 'Control lumbopélvico', icon: ShieldCheck },
        { text: 'Historial isquios', icon: Activity }
      ].map(({ text, icon: Icon }) => (
        <div key={text} className="flex items-center gap-2 rounded-lg border border-stroke px-2 py-1.5 text-[10px]">
          <Icon className="h-3.5 w-3.5 text-brand-500" />
          <span className="text-slate-700">{text}</span>
        </div>
      ))}
    </div>
  );
}

export function PhoneMockup({ variant, rotate = '' }: PhoneMockupProps) {
  return (
    <div
      className={`w-[170px] rounded-[26px] border-4 border-slate-900 bg-white p-2 shadow-card sm:w-[200px] ${rotate}`}
      aria-hidden="true"
    >
      <div className="mx-auto mb-2 h-1.5 w-14 rounded-full bg-slate-300" />
      <div className="overflow-hidden rounded-[18px] bg-canvas p-2">
        <div className="mb-2 flex items-center justify-between text-[10px] text-slate-500">
          <span>+Trainer</span>
          <span className="flex items-center gap-1">
            <CalendarRange className="h-3 w-3" /> Hoy
          </span>
        </div>

        {variant === 'planning' ? <PlanningUi /> : null}
        {variant === 'monitoring' ? <MonitoringUi /> : null}
        {variant === 'injury' ? <InjuryUi /> : null}

        <div className="mt-2 flex items-center justify-between rounded-lg bg-white px-2 py-1 text-[9px] text-slate-500">
          <BarChart3 className="h-3 w-3 text-brand-500" />
          <Activity className="h-3 w-3 text-brand-500" />
          <ShieldCheck className="h-3 w-3 text-brand-500" />
        </div>
      </div>
    </div>
  );
}
